import React from 'react'
import { Link } from 'react-router-dom'

function Vistagrabgo() {
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi Verticals -</Link>
           <span className="block py-1 pl-4 mt-6">Vista Grab & Go</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/vistagrabgo.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Vista Grab & Go</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Chilled compact display units with large capacity and superior visibility!.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">The VISTA and VISTA SLIM semi-verticals and display cases are ideal for small stores and for when every centimeter counts, maximizing product display and product promotion. The range offers up to four tiers fully refrigerated in a very tiny footprint.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl opacity-90">Refrigerated packaged foods and beverages <span className=' text-blue-500'> -1… +7 °C</span> (3M2)</p>
       <p className="text-xl lg:text-2xl opacity-90">Hot packaged foods and beverages <span className=' text-red-600'>+65 °C</span></p>

    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">R290</p>

         </div>
    
   


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">Maximize rentability in small store spaces</p>
    <div className='mt-6 text-xl md:text-2xl font-thin text-gray-500'>With 4 display levels, fully refrigerated, and heated models with 3 levels, the VISTA semi-verticals are the best partner to boost self-service sales of your packaged products, whether hot or cold.</div>


</div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/vistagrabcase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center mt-16">
  {[
    {
      img: "images/vistagrabcard.jpg",
      text: "High-brightness and low energy consumption LED lighting on all levels.",
    },
    {
      img: "images/vistagrabcard1.jpg",
      text: "Models available with closed backs to lean against the wall or with rear service doors to facilitate product restocking operations.",
    },
    {
      img: "images/vistagrabcard2.jpg",
      text: "Panoramic double-glazed end side panels for greater energy efficiency.",
    },
    {
        img: "images/vistagrabcard4.jpg",
        text: "Night blind curtain for greater energy savings.",
      },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


 {/* case 3 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                {/* ✅ Image Wrapper */}
 <div className="w-full md:w-1/2">
                 <img src="/images/vistacase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">Meals and takeaway always warm and delicious</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Roast chicken, pasta, soups, noodles... the heated semi-verticals VISTA always guarantee the best visibility and convenience to your customers.</div>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>With an innovative ventilated heating system, it is 20% more energy efficient when compared to contact heating systems and conventional heating lamps.</div>

</div>
 
             </div>

            
     </div>
     {/* carosel */}
    
  
        </div>
      )
    }

export default Vistagrabgo